export const DEFAULT_TIANLAN_CUSTOMER_THEME = {
  pageBackgroundColor: '#f5f5f7',
  cardBackgroundColor: '#ffffff',
  tabletFrameBackgroundColor: '#000000',
  buttonColor: '#0071e3',
  accentColor: '#0071e3',
};

const LEGACY_THEME = {
  pageBackgroundColor: '#f7f5f0',
  cardBackgroundColor: '#fffdf8',
  buttonColor: '#1f7895',
  accentColor: '#1f7895',
};

export function normalizeTianlanCustomerTheme(theme = {}) {
  const normalized = { ...DEFAULT_TIANLAN_CUSTOMER_THEME, ...theme };
  const isUntouchedLegacyTheme = Object.entries(LEGACY_THEME).every(
    ([key, value]) => String(normalized[key] || '').toLowerCase() === value,
  );

  return isUntouchedLegacyTheme
    ? { ...normalized, ...DEFAULT_TIANLAN_CUSTOMER_THEME }
    : normalized;
}
